export function calculateWidth(item: { title: string, field: string }, isLast: boolean, data: Array<any>): object {
    if (item.field === 'documents' || item.field === 'couleurs')
        return { width: 120 };

    if (item.field === 'actions')
        return { width: 80 }

    if (item.field === 'statuts')
        return { width: 200 };

    if (item.field === 'approuve')
        return { width: 200 };

    if (item.field === 'caracteristiques')
        return { width: 200 }

    const headerSize = calculateTextWidth(item.title);
    let maxWidth = headerSize;

    data.forEach((value) => {
        const contentSize = calculateTextWidth(value[item.field]);

        if (contentSize > maxWidth)
            maxWidth = contentSize > 200 ? 200 : contentSize;
    })

    return { width: maxWidth };
}

function calculateTextWidth(text: string) {
    let element = document.createElement('canvas');
    let context = element.getContext("2d")!;
    context.font = '1rem system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'

    return context.measureText(text).width + 50;
}